import { PriceCalculatorFormData } from "@/features/price-calculator/types/types";
import { Column, Text } from "@stenajs-webui/core";
import { Banner } from "@stenajs-webui/elements";
import { TableHeadItem, TableHeadRow } from "@stenajs-webui/grid";
import React, { Fragment } from "react";
import { FormModelChangeHandler } from "../../../../../types/forms/types";
import { PriceCalculatorLegRow } from "./PriceCalculatorLegRow";

interface Props {
  formData: PriceCalculatorFormData;
  onChangeFormData: FormModelChangeHandler<PriceCalculatorFormData>;
  defaultFormState: PriceCalculatorFormData;
}

export const PriceCalculatorLegsTable: React.FC<Props> = ({
  formData,
  onChangeFormData,
  defaultFormState,
}) => {
  if (!formData.multiLegRouteData) {
    return (
      <Banner
        headerText={"Select a route"}
        text={"Legs will be shown here"}
        variant={"info"}
      />
    );
  }

  return (
    <Column>
      <TableHeadRow>
        <TableHeadItem justifyContent={"flex-start"} width={56}>
          <Text size={"small"} variant={"bold"}>
            #
          </Text>
        </TableHeadItem>
        <TableHeadItem width={64}>
          <Text size={"small"} variant={"bold"}>
            Leg
          </Text>
        </TableHeadItem>
        <TableHeadItem width={150}>
          <Text size={"small"} variant={"bold"}>
            Date
          </Text>
        </TableHeadItem>
        <TableHeadItem width={190}>
          <Text size={"small"} variant={"bold"}>
            Timetable
          </Text>
        </TableHeadItem>
        <TableHeadItem width={170}>
          <Text size={"small"} variant={"bold"}>
            Departure Category
          </Text>
        </TableHeadItem>
        <TableHeadItem width={140}>
          <Text size={"small"} variant={"bold"}>
            Departure Time
          </Text>
        </TableHeadItem>
      </TableHeadRow>
      {formData?.routeLegs?.map((routeLeg, index) => (
        <Fragment key={index}>
          <PriceCalculatorLegRow
            routeLeg={routeLeg}
            index={index}
            formData={formData}
            onChangeFormData={onChangeFormData}
            defaultFormState={defaultFormState}
          />
        </Fragment>
      ))}
    </Column>
  );
};
